import * as React from "react";
import refreshnews from "@/assets/images/features/BasicProfile/refreshnews.svg";
export interface IErrorMsg {
  icon?: string;
  msg?: string;
  refresh?: boolean;
  refreshFunc?: Function;
  parentClass?: string;
  showIcon?: boolean;
  paths?: React.ReactNode;
  customMsg?: React.ReactNode;
}
const Errormsg: React.FC<IErrorMsg> = (props: IErrorMsg) => {
  return (
    <>
      <div
        className={`error-msg ${props.parentClass ? props.parentClass : ""}`}
      >
        <div className="error-msg-wrapper">
          {props.showIcon === false ? (
            <> </>
          ) : (
            <div>
              <i
                className={`erroricon  ${
                  props.icon ? props.icon : "edel-icon-error-msg-icon"
                }`}
              >
                {props?.paths && props?.paths}
              </i>
            </div>
          )}
          {props.customMsg ? (
            <div className="taCenter mgt-18">{props.customMsg}</div>
          ) : (
            <div className="error-msg-text">
              {props.msg ? (
                <span dangerouslySetInnerHTML={{ __html: props.msg }}></span>
              ) : (
                "We ran in to some technical difficulties  please click refresh and try again"
              )}
            </div>
          )}

          {props.refresh === true && (
            <div className="refreshErrorBtn">
              <button
                className="btn d-flex align-items-center"
                onClick={() => props.refreshFunc()}
              >
                <div className="refreshErrorBtn-icon">
                  <i className="d-flex edel-icon-double-refresh"></i>
                </div>
                <p>Refresh</p>
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Errormsg;
